module.exports = __webpack_public_path__ + "img/DomainDisabledOutlined.761784f5.svg";